import {
  requestPostList,
  requestSavePost,
} from '@/api/post';

const state = {
  postList: null,
  page: null,
  postResult: null,
};

const getters = {
  postList: (state) => state.postList,
  page: (state) => state.postList.page,
  postResult: (state) => state.postResult,
};

const actions = {
  async getPostList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPostList({ pageNumber });
    commit('setPostList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async savePost({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    const csrfToken = rootGetters.csrf;
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestSavePost({ csrfToken, postParams });
    commit('setPostResult', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    await dispatch('setIsLoading', false, { root: true });
  },
  clearPostResult({ commit }) {
    commit('setPostResult', null);
  },
};

const mutations = {
  setPostList(state, postList) {
    state.postList = postList;
  },
  setPostResult(state, postResult) {
    state.postResult = postResult;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
